import { isBrowser } from 'src/lib/util/dom'

const isTest = () => {
  if (!process.env) {
    return false
  }

  return process.env.NODE_ENV === 'test'
}

const config = isBrowser && !isTest() ? ((window as $TSFixMe).__env || {}) : process.env
export default config